import { MenuItem } from "@mui/material";
import { capitalize } from "lodash";
import { useContext } from "react";

import { Box } from "@/Components/v2/atoms/Box";
import { Divider } from "@/Components/v2/atoms/Divider";
import { FormControl } from "@/Components/v2/atoms/FormControl";
import { Select } from "@/Components/v2/atoms/Select";
import { Stack } from "@/Components/v2/atoms/Stack";
import { BoldSpan, Typography } from "@/Components/v2/atoms/Typography";

import { ChatContext } from "../context/ChatContextProvider";
import { ModelDescriptions } from "../types";

type ModelSelectProps = {
  width?: string;
};

export const ModelSelect = ({ width = "280px" }: ModelSelectProps) => {
  const context = useContext(ChatContext);

  const options = context?.modelOptions.map((option) => ({
    value: option.value,
    label: capitalize(option.label),
    description: ModelDescriptions[option.value as keyof typeof ModelDescriptions],
  }));

  return (
    <FormControl size="small" sx={{ width }}>
      <Select
        labelId="model-select-label"
        id="model-select"
        value={context?.selectedModel || ""}
        onChange={(event) => {
          context?.setSelectedModel(event.target.value);
        }}
        renderValue={(value) => (
          <Typography fontSize={14}>
            <BoldSpan>Base Model: </BoldSpan>
            {options?.find((option) => option.value === value)?.label}
          </Typography>
        )}
        MenuProps={{
          PaperProps: {
            sx: { width },
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        }}
      >
        {options?.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ py: 1 }}>
            <Stack direction="column" gap={0.5}>
              <Typography fontWeight={600} fontSize={14}>
                {option.label}
              </Typography>
              <Typography fontSize={12} whiteSpace="normal">
                {option.description}
              </Typography>
            </Stack>
          </MenuItem>
        ))}
        <Divider />
        <Box sx={{ px: 2, py: 0.5 }}>
          <Typography fontSize={12}>
            <BoldSpan>Note: </BoldSpan>
            <Typography fontSize={12} component="span" fontStyle="italic">
              All models are hosted on Mutinex Cloud Storage. Your data remains fully segregated and
              will never be shared.
            </Typography>
          </Typography>
        </Box>
      </Select>
    </FormControl>
  );
};
